<template>
  <el-dialog v-model="visible" :title="action === 'move' ? '移动到...' : '复制到...'" width="350" append-to-body
    :close-on-click-modal="false" @close="onClose">
    <div class="move-dialog">
      <div class="row">
        <el-select v-model="selectedTeam" class="team-select" placeholder="选择团队" :teleported="false"
          @change="onTeamChange">
          <el-option label="我的空间" value=" " />
          <el-option :label="currentTeam.name" :value="currentTeam.corp_code" />

        </el-select>
      </div>
      <div class="row header h-[40px]">
        <div class="label">请选择</div>
        <div class="search-wrap">
          <el-input v-if="showSearch" ref="searchRef" v-model="keyword" placeholder="搜索" class="search-input" clearable
            @input="onFilter" @blur="onSearchBlur" />
          <el-icon v-else class="search-icon" @click="openSearch">
            <Search />
          </el-icon>
        </div>
      </div>
      <div class="tree-wrap" v-if="treeData.length > 0">
        <el-tree ref="treeRef" :data="treeData" node-key="folder_id" :props="{ label: 'name', children: 'children' }"
          highlight-current @node-click="onNodeClick" :filter-node-method="filterNode" />
      </div>
      <div class="no-data" v-else>暂无文件夹</div>
      <div class="footer">
        <el-button @click="onCancel">取消</el-button>
        <el-button type="primary" @click="onConfirm">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted, nextTick } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
import { getFolderTree } from '@/api/affairs'
import { resourceMove, resourceCopy } from '@/api/ResourceMasonry'
import { useUserStore } from '@/stores/user'
import { multipleChoiceStore } from "@/stores/multipleChoice"
const multipleChoice = multipleChoiceStore()
const userStore = useUserStore()
const props = defineProps({
  modelValue: { type: Boolean, default: false },
  current: { type: Object, default: () => ({}) },
  teams: { type: Array as () => string[], default: () => [] },
  type: { type: String, default: 'folder' },
  corpCode: { type: String, default: '' },
  resource: { type: Object, default: () => ({}) },
  action: { type: String, default: 'move' },
  multiple: { type: Boolean, default: false }

})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const visible = ref(props.modelValue)
watch(() => props.modelValue, v => visible.value = v)
watch(visible, v => emit('update:modelValue', v))

const selectedTeam = ref(' ')
const keyword = ref('')
const treeRef = ref()
const treeData = ref<any[]>([])
const selectedFolderId = ref<string | number>('')
const showSearch = ref(false)
const searchRef = ref()

const loadTree = async (corpCode?: string) => {
  selectedFolderId.value = ''
  clearSelection()
  try {
    const res = await getFolderTree({ corp_code: corpCode })
    const items = res.data?.data || []
    const normalize = (list: any[]) => list.map(x => ({
      folder_id: x.folder_id ?? x.id,
      name: x.name,
      children: Array.isArray(x.children) ? normalize(x.children) : []
    }))
    treeData.value = normalize(items)
  } catch { }
}
const currentTeam = ref<any>({})
onMounted(() => {
  selectedTeam.value = ' '
  currentTeam.value = userStore.currentTeamInfo || {}
  if (visible.value) loadTree()
})
const onClose = () => {
  selectedTeam.value = ' '
  clearSelection()
}
watch(visible, v => { if (v) loadTree() })

const clearSelection = () => {
  selectedFolderId.value = ''
    ; (treeRef.value as any)?.setCurrentKey?.(null)
}
const onNodeClick = (data: any) => {
  if (selectedFolderId.value === data.folder_id) {
    clearSelection()
  } else {
    selectedFolderId.value = data.folder_id
  }
}
const filterNode = (value: string, data: any) => {
  if (!value) return true
  return String(data.name || '').toLowerCase().includes(String(value).toLowerCase())
}
const onFilter = () => { (treeRef.value as any)?.filter?.(keyword.value) }

const onCancel = () => { visible.value = false; emit('cancel') }
const onConfirm = () => {
  if (props.multiple) {
    multipleConfirm()
    return
  }
  let params = {
    kind: props.type,
    to_owner_type: selectedTeam.value === ' ' ? 'user' : 'team',
    to_corp_code: selectedTeam.value,
    to_folder_id: selectedFolderId.value || undefined,
    from_corp_code: props.corpCode,
    resource_id: props.resource.id,
    folder_id: props.current.folder_id,
    from_owner_type: props.corpCode ? 'team' : 'user',
  }
  if (props.action === 'move') {
    resourceMove(params).then(res => {
      visible.value = false
      emit('confirm', { targetFolderId: selectedFolderId.value, team: selectedTeam.value, current: props.current })
    })
  } else if (props.action === 'copy') {
    resourceCopy(params).then(res => {
      visible.value = false
      emit('confirm', { targetFolderId: selectedFolderId.value, team: selectedTeam.value, current: props.current })
    })
  }

}
const openSearch = async () => {
  showSearch.value = true
  await nextTick()
    ; (searchRef.value as any)?.focus?.()
}
const onSearchBlur = () => {
  showSearch.value = false
}

const onTeamChange = (val: string) => {
  loadTree(val)
}
const multipleConfirm = async () => {
  // folder
  let resource_ids = multipleChoice.selectedResources.join(',')
  let folder_ids = multipleChoice.selectFolder.join(',')
  let params = {
    kind: 'resource',
    to_owner_type: selectedTeam.value === ' ' ? 'user' : 'team',
    to_corp_code: selectedTeam.value,
    to_folder_id: selectedFolderId.value || undefined,
    from_corp_code: props.corpCode,
    resource_id: '',
    folder_id: '',
    from_owner_type: props.corpCode ? 'team' : 'user',
  }
  try {
    if (resource_ids) {
      params.kind = 'resource'
      params.resource_id = resource_ids
      if (props.action === 'move') {
        await resourceMove(params)
      }
      if (props.action === 'copy') {
        await resourceCopy(params)
      }
    }
    if (folder_ids) {
      params.kind = 'folder'
      params.folder_id = folder_ids
      if (props.action === 'move') {
        await resourceMove(params)
      }
      if (props.action === 'copy') {
        await resourceCopy(params)
      }
    }
    emit('confirm')
  } catch {
    emit('confirm')
  }
}
</script>
<style lang="scss" scoped>
.move-dialog {
  padding: 4px 8px 8px;
}

.row {
  margin-bottom: 10px;
}

.row.label {
  color: #606266;
  font-size: 13px;
}

.row.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-wrap {
  display: flex;
  align-items: center;
}

.search-input {
  width: 220px;
}

.search-icon {
  cursor: pointer;
  color: #606266;
}

.team-select {
  width: 100%;
}

.tree-wrap {
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 8px;
  max-height: 280px;
  overflow: auto;
}

:deep(.el-tree-node__content) {
  height: 10px;
  line-height: 10px;
  border-radius: 8px;
  padding: 0 8px;
}

:deep(.el-tree-node.is-current > .el-tree-node__content) {
  background-color: #eaf2ff;
}

:deep(.el-tree-node.is-current > .el-tree-node__content .el-tree-node__label) {
  color: #2a66ff;
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 12px;
}
</style>
<style>
.el-text.is-truncated {
  display: inline-block;
  height: 30px;
  line-height: 30px;
}

.move-dialog .el-tree-node__content {
  height: 30px !important;
  line-height: 30px;
}
</style>
